import React, { Component } from 'react';

class MatrixChart extends Component<Props> {
  render() {
    const { data, labels } = this.props;
    if (!data || !labels || data.length === 0 || labels.length === 0) {
      return <div className='text-center text-f-black-3'>No data available</div>;
    }

    const maxValue = Math.max(...data.flat());
    const getColor = (value: number) => {
      const alpha = value / maxValue;
      return `rgba(114, 142, 255, ${0.1 + alpha * 0.9})`;
    };

    return (
      <div className='flex flex-col items-center justify-center h-full w-full p-4'>
        <div className='flex items-center w-full mb-2'>
          <div className='transform -rotate-90 text-sm font-medium text-f-black-2 whitespace-nowrap'>Actual</div>
          <div className='flex-1'>
            <div className='grid grid-cols-1 gap-2'>
              {data.map((row, i) => (
                <div key={`row-${i}`} className='flex gap-2'>
                  {row.map((value, j) => (
                    <div
                      key={`cell-${i}-${j}`}
                      style={{
                        backgroundColor: getColor(value),
                        width: '100%',
                        aspectRatio: '1',
                      }}
                      className='flex flex-col items-center justify-center border border-f-gray-3 rounded-md transition-all hover:shadow-md h-[140px] max-h-1/2'
                    >
                      <div className='text-lg font-semibold text-f-black-2'>{value}</div>
                      <div className='text-xs text-f-black-3 mt-1'>{i === 0 ? (j === 0 ? 'TN' : 'FP') : j === 0 ? 'FN' : 'TP'}</div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className='flex justify-center mt-2'>
          <div className='text-sm font-medium text-f-black-2'>Predicted</div>
        </div>

        <div className='flex justify-center items-center gap-6 mt-4'>
          {[1, 0.5, 0.25].map((ratio, index) => (
            <div key={`legend-${index}`} className='flex items-center gap-2'>
              <div className='w-3 h-3 rounded-sm' style={{ backgroundColor: getColor(maxValue * ratio) }} />
              <span className='text-xs text-f-black-3'>{index === 0 ? 'High' : index === 1 ? 'Medium' : 'Low'}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

interface Props {
  data: number[][];
  labels: string[];
}

export default MatrixChart;
